export default __webpack_public_path__ + "static/media/260.2d60f2be.gif";